module.exports = __webpack_public_path__ + "static/mock-interview-2b49df034c16c794417ed5d8da57a329.jpg";